import * as React from 'react';
import { RouteComponentProps, withRouter } from 'react-router';

export type InternalLinksProps = {
    domainnames: string[];
};
type Props =
    RouteComponentProps<any> &
    InternalLinksProps;

const isModifiedEvent = (event: MouseEvent) => {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
};

class InternalLinks extends React.Component<Props> {
    private observer: MutationObserver;

    private isInternal: RegExp;
    constructor(props: Props) {
        super(props);

        this._addLink = this._addLink.bind(this);
        this._CheckElements = this._CheckElements.bind(this);
        const pattern = "^(\/|(https?\:\/\/(www\.)?)(" + this.props.domainnames.join('|') + ")($|\/.*$))";
        this.isInternal = new RegExp(pattern);
    }
    componentDidMount() {
        this.observer = new MutationObserver((mutations) => {
            // For the sake of...observation...let's output the mutation to console to see how this all works
            mutations.forEach((mutation) => {
                mutation.addedNodes.forEach(this._CheckElements);
            });
        });

        const observerConfig = {
            childList: true,
            subtree: true
        };

        const targetNode = document.body;

        this.observer.observe(targetNode, observerConfig);

        this._CheckElements(targetNode);
    }
    componentDidUpdate(oldProps: Props) {
        if (oldProps.domainnames.join(",") !== this.props.domainnames.join(",")) {
            const pattern = "^(\/|(https?\:\/\/(www\.)?)(" + this.props.domainnames.join('|') + ")($|\/.*$))";
            this.isInternal = new RegExp(pattern);
        }
    }
    componentWillUnmount() {

        this.observer.disconnect();
    }

    public render() {

        return this.props.children;
    }
    // https://github.com/ReactTraining/react-router/blob/master/packages/react-router-dom/modules/Link.js
    private _handleClick(a: HTMLAnchorElement, event: MouseEvent, path: string) {
        if (
            !event.defaultPrevented && // onClick prevented default
            event.button === 0 && // ignore everything but left clicks
            (!a.target || a.target === "_self") && // let browser handle "target=_blank" etc.
            !isModifiedEvent(event) // ignore clicks with modifier keys
        ) {
            const { history: { push } } = this.props;
            event.preventDefault();
            push(path);
        }
    }
    private _addLink(a: HTMLAnchorElement) {
        if (a.dataset.routed) { return; }
        a.dataset.routed = "true";
        const href = a.href;
        const internal = this.isInternal.exec(href);
        if (!internal || !internal.length) { return; }
        const path = internal[internal.length - 1];
        
        // a.addEventListener("mousedown", (e) => {
        //     e.stopPropagation();
        //     e.stopImmediatePropagation();
        //     // this._handleClick(a, e, path);
        // });

        a.addEventListener("click", (e) => {
            this._handleClick(a, e, path);
        });
        a.dataset.intercept = "true";
    }

    private _CheckElements(node: Node) {

        if (!(node instanceof HTMLElement)) { return; }
        node.querySelectorAll("a").forEach(this._addLink);
        if (node.tagName.toLowerCase() === "a") {
            this._addLink(node as HTMLAnchorElement);
        }

    }

}

export default withRouter(InternalLinks);


// WEBPACK FOOTER //
// ./src/_context/InternalLinks.tsx